import { CommonModule } from '@angular/common';
import { Component, computed } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Icon, ModalBasement, ModalContainer } from '@millionshow/client-libs';

interface ApplicationCompleteModalProps {
  eventTitle: string;
  name: string;
  contact: string;
}

@Component({
  selector: 'app-registration-complete-modal',
  templateUrl: './registration-complete.modal.html',
  imports: [CommonModule, ModalContainer, Icon, RouterLink],
})
export class RegistrationCompleteModal extends ModalBasement<ApplicationCompleteModalProps> {
  eventTitle = computed(() => this.props()?.eventTitle || '');
  name = computed(() => this.props()?.name || '');
  contact = computed(() => this.props()?.contact || '');
}
